export default class EventDetailsResponse {
    constructor(supportedLocales) {
        this.id = null;
        this.status = null;
        this.image = null;
        this.creator = null;
        this.background = null;
        this.longitude = null;
        this.latitude = null;
        this.createDate = null;
        this.start = null;
        this.end = null;
        this.localizationTolerance = undefined;
        this.translations = [];
        this.participants = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                description: null,
            };
        });
        this.supportedLocales = supportedLocales;
        this.dateRange = [];
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;
            to.status = from.status;
            to.image = from.image;
            to.creator = from.creator;
            to.background = from.background;
            to.longitude = from.longitude;
            to.latitude = from.latitude;
            to.localizationTolerance = from.localizationTolerance;
            to.start = new Date(from.start);
            to.createDate = new Date(from.createDate);
            to.end = new Date(from.end);
            to.participants = from.participants;
            to.supportedLocales?.forEach((element) => {
                to.translations[element] = {
                    title: from.translations[element]?.title,
                    description: from.translations[element]?.description,
                };
            });
            to.dateRange=[new Date(from.start),new Date(from.end)];
        } else {
            to = new EventDetailsResponse();
        }
    }

    static copy(to, from) {
        EventDetailsResponse.assign(from, to);
        return to;
    }
}
